export default "<p>create-record works!</p>\n"